import { Component, Input, OnInit, EventEmitter, Output, ViewChild, NgZone, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { constants } from '../../utitlity/constant';
import { Helper } from '../../utitlity/helper';
import { ApplicationPage } from '../../models/application-form.model';
import { Router, ActivatedRoute } from '@angular/router';
import { LeadFormService } from './../../services/lead-form.service';
import * as _ from 'lodash';
import { Title } from '@angular/platform-browser';
import { tealiumConstants } from '../../utitlity/tealium.constants';
import {TealiumAction} from '../../models/tealium.action';

 var TMS:any;

@Component({
    selector: "lead-form",
    template: require('./lead-form.component.html'),
    styles: [require('./lead-form.component.css')]
})
export class LeadFormComponent extends TealiumAction  implements OnInit  {
    appRefNumber: any;
    applicationAEMResponse: any;
    questions: any;
    aelList: any;
    isLoaded: boolean;
    isFeedbackForm: boolean;
    showThankyou: boolean;
    thankyouMessage: string;
    thankyoupage: any;

    leadFormDetails: any;
    leadManagementDetails: any;
    TMStrackViewObj: any;
    TMStrackEventObj: any;

    constructor(private leadFormService: LeadFormService,
                private router: Router,
                private zone: NgZone,
                private cd: ChangeDetectorRef,
                private activatedRoute: ActivatedRoute,
                private titleService: Title) {
                    super();
    }
    ngOnInit() {
        this.initialiseObjects();
    }
    assignTMSValues() {
        if (constants.LEAD_FORM_PRODUCT_CODE == this.applicationAEMResponse["productDetails"]["productCode"]) {
            console.log(JSON.stringify(this.applicationAEMResponse))
            tealiumConstants.page_name = this.applicationAEMResponse.productDetails.productName;
            tealiumConstants.page_url = window.location.pathname+window.location.hash;
            tealiumConstants.page_type = "application";
            tealiumConstants.page_category = "public";
            tealiumConstants.page_subcategory = this.applicationAEMResponse.productDetails.productSubCategory;
            tealiumConstants.product_id = this.applicationAEMResponse.productDetails.productCode;
            tealiumConstants.product_category = this.applicationAEMResponse.productDetails.productCategory;
            tealiumConstants.product_subcategory = this.applicationAEMResponse.productDetails.productSubCategory;
            
            // if(this.applicationAEMResponse.productDetails.productName.toLowerCase().indexOf('loan') != -1) {
            //     tealiumConstants.product_category = 'loans';
            //     tealiumConstants.page_subcategory = 'Loan';
                
               
            // } else if(this.applicationAEMResponse.productDetails.productName.toLowerCase().indexOf('account') != -1) {
            //     tealiumConstants.page_subcategory = 'accounts';
            //     tealiumConstants.product_category = 'Accounts';
                
            // } else if(this.applicationAEMResponse.productDetails.productName.toLowerCase().indexOf('insurance') != -1) {
            //     tealiumConstants.page_subcategory = 'Insurance';
            //     tealiumConstants.product_category = 'Insurance';
            // } else if(this.applicationAEMResponse.productDetails.productName.toLowerCase().indexOf('card') != -1) {
            //     tealiumConstants.page_subcategory = 'Cards';
            //     tealiumConstants.product_category = 'credit cards';
                
            // } else {
            //     tealiumConstants.page_subcategory = 'Others';
            //     tealiumConstants.product_category = 'Others';
            // };

            let _obj = {
                page_name : tealiumConstants.page_name,
                page_url : tealiumConstants.page_url,
                page_type : tealiumConstants.page_type,
                page_category :  tealiumConstants.page_category,
                page_subcategory : tealiumConstants.page_subcategory,
                product_id : tealiumConstants.product_id,
                product_category : tealiumConstants.product_category,
                product_subcategory : tealiumConstants.product_subcategory,
            };
            this.TMStrackViewObj = _obj;
        }
    }
    assignTMSThankyouValues() {
        this.assignTMSValues();
        this.TMStrackViewObj["page_url"] = window.location.pathname + window.location.hash + "" + "/thankyou";
        this.TMStrackEventObj = {...this.TMStrackViewObj};

        let _eventobj = {
            event_category : 'application',
            event_action : 'submit',
            event_content : 'display',
            application_event : 'submitted'
        }
        this.TMStrackEventObj = {..._eventobj, ...this.TMStrackEventObj};
    }
    initialiseObjects() {
        this.isLoaded = false;
        this.showThankyou = false;
        this.isFeedbackForm = false;
        this.leadFormDetails = new Object();

        if(constants.LEAD_FORM_PRODUCT_CODE === 'FB' || constants.LEAD_FORM_PRODUCT_CODE === 'O/D') {
            // this.isFeedbackForm = true;
        }
        this.thankyouMessage = constants.THANKYOU_MESSAGE;
        this.thankyoupage = new Object();

        Helper.enableSpinner(true);

        //Temporary code
        let productCode = JSON.parse(JSON.stringify(constants.LEAD_FORM_PRODUCT_CODE));

        Promise.all([this.leadFormService.getLeadFormPageData(productCode,this.isFeedbackForm),this.leadFormService.getAelList()])
            .then((response)=> {
                if(_.isEmpty(response[0])) {
                    this.redirectPageTo("/error");
                } else {
                    this.applicationAEMResponse = JSON.parse(JSON.stringify(response[0]));
                    console.log("AEM Response")
                    console.log(this.applicationAEMResponse)
                    this.leadFormService.setLeadProductDetails(this.applicationAEMResponse);
                    this.aelList = JSON.parse(JSON.stringify(response[1]));
                    let modifiedAppData = new ApplicationPage(this.applicationAEMResponse);
                    this.questions = modifiedAppData.applicationForm.sections;

                    let productTitle = 'HSBC ' + this.applicationAEMResponse["productDetails"]["productName"];
                    this.setApplicationTitle(productTitle);

                    this.assignTMSValues();
                    this.trackView(this.TMStrackViewObj);

                    Helper.enableSpinner(false);
                    this.isLoaded = true;
                }
            }, (err) => {
                Helper.enableSpinner(false);
                this.redirectPageTo("/error");
            });
    }
    redirectPageTo(page) {
        Helper.enableSpinner(false);
        this.zone.run(()=>{
            this.router.navigate([page]);
        });
    }
    onFieldChange(event) {
    }
    onTypeaheadFieldChange(event) {
    }
    getRows(panel) {
        return Object.keys(panel.panelRows);
    }
    getKeys(pnl) {
        return Object.keys(pnl);
    }
    submitForCallback() {
        this.createLeadFormRequestObject();
        this.createLeadManagementRequestObject();

        let leadFormDetails = JSON.parse(JSON.stringify(this.leadFormDetails));
        let leadManagementDetails = JSON.parse(JSON.stringify(this.leadManagementDetails));

        let finalLeadFormDetails = {...leadFormDetails, ...leadManagementDetails};
        console.log("Lead form submission");
        console.log(this.questions);
        console.log("Lead form data");
        console.log(this.leadFormDetails);
        console.log("Lead form management data");
        console.log(this.leadManagementDetails);
        console.log("Final lead form data");
        console.log(finalLeadFormDetails);

        finalLeadFormDetails["title"] = finalLeadFormDetails["title"]["name"];
        finalLeadFormDetails["phoneNo"] = "971" + finalLeadFormDetails["phoneNo"];
        finalLeadFormDetails["company"] = finalLeadFormDetails["company"]["name"] ? finalLeadFormDetails["company"]["name"] : finalLeadFormDetails["company"];

        Helper.enableSpinner(true);

        this.leadFormService.leadFormSubmission(finalLeadFormDetails)
            .then((response) => {
                Helper.enableSpinner(false);
                this.showThankyou = true;
                this.assignTMSThankyouValues();
                this.trackEvent(this.TMStrackEventObj);

                this.trackView(this.TMStrackViewObj);

            }, (err) => {
                Helper.enableSpinner(false);
                this.redirectPageTo("/error");
            });
    }
    createLeadFormRequestObject() {
        let panelRows = this.questions[0]["panels"][0]["Panel1"]["panelRows"];
        let panelRowsLength = Object.keys(panelRows).length;

        for(let i = 1; i <= panelRowsLength; i++) {
            for(let item of panelRows['Row'+i]) {
                if(item["backendField"] && item["backendField"] != '' && item["show"]) {
                    this.leadFormDetails[item["backendField"]] = item["value"];
                }
            }
        }
    }
    createLeadManagementRequestObject() {
        let leadManagementDetails = {
            "appRefNo": this.appRefNumber,
            "leadSrcID": "PWS",
            "maintenanceID": "A",
            "marketSector": "",
            "marketSectorValue": this.applicationAEMResponse["productDetails"]["msCode"],
            "potentialNo": "",
            "productType": this.applicationAEMResponse["productDetails"]["productCode"],
            "productDescription": this.applicationAEMResponse["productDetails"]["productName"],
            "productFlag": "S",
            "promoCode": "",
            "resultType": "SL1",
            "segNo": "1",
            "sourceDetails": "XYZ",
            "peopleSoftId": "",
            "currency": "AED",
            "type": "FORM_DATA"
        }
        this.leadManagementDetails = JSON.parse(JSON.stringify(leadManagementDetails));
    }
    openTnCWindow() {
        window.open(this.applicationAEMResponse.pageMessages.tncLink);
    }
    callUsBtnClick() {
        window.open(this.thankyoupage["callUsButtonLink"]);
    }
    findOutMoreBtnClick() {
        window.open(this.thankyoupage["findOutMoreButtonLink"]);
    }
    checkIfIncomeIsValid() {
        let hasMonthlyIncomeField = false;
        let monthlyIncome = 0;
        let isMonthlyIncomeValid = true;

        let panelRows = this.questions[0]["panels"][0]["Panel1"]["panelRows"];
        let panelRowsLength = Object.keys(panelRows).length;
           
        for(let i = 1; i <= panelRowsLength; i++) {
            for(let item of panelRows['Row'+i]) {
                if(item["backendField"] && item["backendField"] == 'monthlyIncome' && item["show"]) {
                    hasMonthlyIncomeField = true;
                    monthlyIncome = item["value"];
                    break;
                }
            }
            if(hasMonthlyIncomeField) {
                break;
            }
        }

        if(hasMonthlyIncomeField) {
            let productDetails = this.leadFormService.getLeadProductDetails()["productDetails"];
            let minMonthlyIncome = parseInt(productDetails["minimumMonthlyIncome"]);

            if(monthlyIncome < minMonthlyIncome) {
                isMonthlyIncomeValid = false;
            }
        }
        return isMonthlyIncomeValid;
    }
    setApplicationTitle(newTitle: string) {
        this.titleService.setTitle( newTitle );
    }
 }


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/components/lead-form/lead-form.component.ts